export const tempTimelineData = [
  {
    _id: 'ajsdlj807080799696696',
    dateFrom: "1978-05-16",
    dateTo: "1978-05-16",
    dateCreated: {
      "$date": "1978-05-16T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2022-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    images: [
      {
        _id: "234760945",
        name: "ashley-and-jesse",
      },
      {
        _id: "92378",
        name: "ashley-and-jesse",
      },
      {
        _id: "309476",
        name: "ashley-and-jesse",
      },
      {
        _id: "673948759834",
        name: "ashley-and-jesse",
      },
    ],
    mainImage: {
      _id: "394720",
      name: "ashley-and-jesse",
    },
    public: true,
    tags: ["denny"],
    title: 'Denny was born',
  },
  {
    _id: 'fjakdf8877',
    dateFrom: "1981-03-17",
    dateTo: "1981-03-17",
    dateCreated: {
      "$date": "1981-03-17T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2022-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    images: [
      {
        _id: "234760945",
        name: "ashley-and-jesse",
      },
      {
        _id: "92378",
        name: "ashley-and-jesse",
      },
      {
        _id: "309476",
        name: "ashley-and-jesse",
      },
      {
        _id: "673948759834",
        name: "ashley-and-jesse",
      },
    ],
    mainImage: {
      _id: "394720",
      name: "ashley-and-jesse",
    },
    public: true,
    tags: ["birthday"],
    title: 'I was born',
  },
  {
    _id: 'fjasdfjop',
    dateFrom: "1981-09-22",
    dateTo: "1981-11-01",
    dateCreated: {
      "$date": "1981-09-22T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2022-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    images: [
      {
        _id: "234760945",
        name: "ashley-and-jesse",
      },
    ],
    mainImage: {
      _id: "394720",
      name: "ashley-and-jesse",
    },
    public: true,
    tags: [""],
    title: 'Learned to Walk Learned to Walk Learned to Walk Learned to Walk Learned to Walk ',
  },

  {
    _id: 'nvkdfalhrg',
    dateFrom: "1998-03-17",
    dateTo: "1998-03-17",
    dateCreated: {
      "$date": "1998-03-17T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2021-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    public: true,
    tags: ["birthday"],
    title: '17 Years Old',
  },
  {
    _id: 'nvkdfadjflalhrg',
    dateFrom: "1998-05-13",
    dateTo: "1998-05-13",
    dateCreated: {
      "$date": "1998-05-13T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2021-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    public: true,
    tags: ["concert"],
    title: 'Elton John, Va Beach Amphitheater',
  },
  {
    _id: 'kjrglskdf',
    dateFrom: "1998-05-22",
    dateTo: "1998-05-22",
    dateCreated: {
      "$date": "1998-05-22T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2021-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    public: true,
    tags: ["concert"],
    title: 'Lynard Skynard',
  },
  {
    _id: 'shfkdfgstdgdfkhvkdjfngd',
    dateFrom: "1998-06-17",
    dateTo: "1998-06-17",
    dateCreated: {
      "$date": "1998-06-17T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2021-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    public: true,
    tags: ["concert"],
    title: 'Jimmy Buffett, Va Beach Amphitheater',
  },
  {
    _id: 'dkjgkadfhglshfdlsjfg',
    dateFrom: "1998-06-30",
    dateTo: "1998-06-30",
    dateCreated: {
      "$date": "1998-06-30T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2021-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    public: true,
    tags: ["concert"],
    title: 'Metallica',
  },
  {
    _id: '38475943796475869749853',
    dateFrom: "1998-07-08",
    dateTo: "1998-07-08",
    dateCreated: {
      "$date": "1998-07-08T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2021-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "Me, Dad and Denny",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    public: true,
    tags: ["concert"],
    title: 'Jimmy Page / Robert Plant, Va Beach Amphitheater',
  },
  {
    _id: 'difgdf7475757',
    dateFrom: "1998-07-10",
    dateTo: "1998-07-10",
    dateCreated: {
      "$date": "1998-07-10T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2021-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    public: true,
    tags: ["concert"],
    title: 'Washington Monument',
  },
  {
    _id: 'dnfkjndvalfnsld',
    dateFrom: "1998-09-07",
    dateTo: "1998-09-07",
    dateCreated: {
      "$date": "1998-09-07T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2021-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    public: true,
    tags: ["concert"],
    title: 'Pearl Jam, Va Beach Amphitheater',
  },
  {
    _id: 'kdjrkdvnf8485757',
    dateFrom: "1998-09-11",
    dateTo: "1998-09-11",
    dateCreated: {
      "$date": "1998-09-11T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2021-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    public: true,
    tags: ["concert"],
    title: 'The Allman Brothers Band, Va Beach Amphitheater',
  },
  {
    _id: 'dnfkjnvkd634665',
    dateFrom: "1998-11-03",
    dateTo: "1998-11-03",
    dateCreated: {
      "$date": "1998-11-03T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2021-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "Special Guest: John Hammond\r\n\r\nWent with Dad. I remember B.B. King was seated the entire show and told stories in between songs.",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    public: true,
    tags: ["concert"],
    title: 'B.B. King, Chrysler Hall',
  },

  {
    _id: 'asdkjca0',
    dateFrom: "1999-02-15",
    dateTo: "2000-12-30",
    dateCreated: {
      "$date": "1999-02-15T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2025-01-24T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "Confirmed with pay stubs. Starting pay was $5.25/hr.",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    images: [
      {
        _id: "234760945",
        name: "ashley-and-jesse",
      },
    ],
    mainImage: {
      _id: "394720",
      name: "ashley-and-jesse",
    },
    public: true,
    tags: ["job"],
    title: 'Allied Rental',
  },
  {
    _id: '2475rrghlsdfk',
    dateFrom: "1999-03-17",
    dateTo: "1999-03-17",
    dateCreated: {
      "$date": "1999-03-17T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2021-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    public: true,
    tags: ["birthday"],
    title: '18 Years Old',
  },
  {
    _id: 'dfadsa97979797',
    dateFrom: "1999-04-01",
    dateTo: "2000-04-01",
    dateCreated: {
      "$date": "1999-02-15T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2025-01-24T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "All I really remember was liking the “Blue Ox 40” (40oz bottles of Colt 45).\r\n\r\n I quit the band first because Jarrett was too pussy sounding.\r\n\r\n Dennis quit next for the same reason. Well, maybe not because it was too pussy but because Jarrett was controlling all the music direction.\r\n\r\n There was a night that Jarrett's parents were out of town. It was snowing that night. We drank a ton of beer. Left a case out on the back porch to stay cold. We played and drank. Around midnight or 1am we called Waffle House and asked them how to cook steaks in the oven. Because we wanted steak and eggs. It worked out ok. I think the eggs were overdone and the steaks were way too rare but still good considering. We fell asleep watching a Led Zepplin documentary. I can't remember if it was the same night or another but one night/early in the morning (it was black outside) I drove home in the snow. In my Jeep. It was a light but steady dusting. Enough so that I couldn't see the road. And this was on the interstate. There virtually wasn't anyone else on the road. I remember being scared out of my mind. “No Quarter” was playing. I'd maybe heard it before but never listened to it. This time I listened to it. Could possibly have been the very first time I'd ever heard it. It spoke to me. The blackness, the snow, the fear, the emptiness, the sound of THAT song… I'll never forget. I only slid as I was pulling onto mom's street. Slid and hit the curb. No damage. It was light at that point (I'm remembering now). I believe I went to work at Allied Rental that morning and Troy told on me for reeking of booze. Chris had a little talk with me and sent me home for the day. Fuckin' Troy.\r\n\r\n At Jarrett's house is where I got the call from Bailey.\r\n\r\n Dennis Grillo\r\n Dave Grillo\r\n Jarrett Beeler\r\n Jesse White\r\n\r\n I put the address as Western Branch High School. Don't know Jarrett's parent's address. Dates are a best guess. ",
    descriptionIsHTML: false,
    googleMapIframeSrc: "",
    images: [
      {
        _id: "234760945",
        name: "ashley-and-jesse",
      },
    ],
    mainImage: {
      _id: "394720",
      name: "ashley-and-jesse",
    },
    public: true,
    tags: ["band"],
    title: 'OX',
  },
  {
    _id: 'jgdrf857477383',
    dateFrom: "1999-05-03",
    dateTo: "1999-05-05",
    dateCreated: {
      "$date": "1999-05-03T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "1999-07-31T12:00:00.000Z"
      }
    ],
    datesConfirmed: true,
    description: "Not sure how many nights we stayed, 2 or 3 or so. Found plane ticket stub so Start Date is correct.\r\n\r\nMy first flight. First time to NYC. We saw Cats, I slept through it. We smoked weed on top the roof of the hotel.",
    descriptionIsHTML: false,
    googleMapIframeSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d207794.3156383011!2d-75.66059514083514!3d35.5342812024564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89a45b3ca7736c71%3A0x1b77116175d236b3!2sOuter%20Banks!5e0!3m2!1sen!2sus!4v1752222172026!5m2!1sen!2sus",
    public: true,
    tags: ["high school, new york, new york city, votech"],
    title: 'VoTech Trip to New York',
  },
  {
    _id: 'djsf888734',
    dateFrom: "1999-05-31",
    dateTo: "1999-05-31",
    dateCreated: {
      "$date": "1999-05-31T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "1999-05-31T12:00:00.000Z"
      }
    ],
    datesConfirmed: false,
    description: "Specific date unconfirmed",
    descriptionIsHTML: false,
    googleMapIframeSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d207794.3156383011!2d-75.66059514083514!3d35.5342812024564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89a45b3ca7736c71%3A0x1b77116175d236b3!2sOuter%20Banks!5e0!3m2!1sen!2sus!4v1752222172026!5m2!1sen!2sus",
    public: true,
    tags: ["high school"],
    title: 'High School Graduation',
  },
  {
    _id: '24987t',
    dateFrom: "1999-06-05",
    dateTo: "1999-06-05",
    dateCreated: {
      "$date": "1999-06-05T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "1999-06-05T12:00:00.000Z"
      }
    ],
    datesConfirmed: false,
    description: "Date guessed",
    descriptionIsHTML: false,
    googleMapIframeSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d207794.3156383011!2d-75.66059514083514!3d35.5342812024564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89a45b3ca7736c71%3A0x1b77116175d236b3!2sOuter%20Banks!5e0!3m2!1sen!2sus!4v1752222172026!5m2!1sen!2sus",
    images: [
      {
        _id: "234760945",
        name: "ashley-and-jesse",
      },
    ],
    mainImage: {
      _id: "394720",
      name: "ashley-and-jesse",
    },
    public: true,
    tags: ["high school", "kempsville", "virginia"],
    title: 'Prom',
  },
  { 
    _id: '142478502',
    dateFrom: "1999-07-04",
    dateTo: "1999-07-04",
    dateCreated: {
      "$date": "2021-01-22T12:00:00.000Z"
    },
    datesModified: [
      {
        "$date": "2021-01-22T12:00:00.000Z"
      }
    ],
    datesConfirmed: false,
    description: "Polka Dots\r\n\r\n4th of July\r\n\r\nFirst experience of “The Ultimate”, on top of Jockey's Ridge as fireworks went off in all directions. Hanging out on the beach gazebo drinking Corona's and smoking salem Slim Lights all stolen from mom. Dennis and I finally found some courage to walk up to a couple of chicks at the beach and start a conversation. It turned out to be a mother with her daughter.",
    descriptionIsHTML: false,
    googleMapIframeSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d207794.3156383011!2d-75.66059514083514!3d35.5342812024564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89a45b3ca7736c71%3A0x1b77116175d236b3!2sOuter%20Banks!5e0!3m2!1sen!2sus!4v1752222172026!5m2!1sen!2sus",
    images: [
      {
        _id: "4398570234975",
        name: "dennis-and-jesse",
      },
      {
        _id: "273094786",
        name: "sand-dick",
      },
    ],
    mainImage: {
      _id: "4398570234975",
      name: "dennis-and-jesse",
    },
    public: true,
    tags: ["beach", "north carolina", "summer", "vacation"],
    title: 'Nags Head',
  },
];